import { render, staticRenderFns } from "./ConfigBulkSendSettings.vue?vue&type=template&id=b3e18d10&scoped=true"
import script from "./ConfigBulkSendSettings.vue?vue&type=script&lang=js"
export * from "./ConfigBulkSendSettings.vue?vue&type=script&lang=js"
import style0 from "./ConfigBulkSendSettings.vue?vue&type=style&index=0&id=b3e18d10&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3e18d10",
  null
  
)

export default component.exports